import React from 'react';
import { string, array } from 'prop-types';

// Import components
import { Collapse } from 'reactstrap';

// Import utilities
import { Toggle } from 'components/utilities';

/**
 * Functional compontent thath returns info note about image sizes.
 * Title and list of requirements
 * @param {string} title - title to display
 * @param {array} requirements - array of requirements to display
 * @returns {*}
 */
const InfoTitleCollapse = ({ title, requirements }) => {
	return (
		<Toggle>
			{({ on, toggle }) => (
				<>
					<h4 onClick={toggle} className="productization-note__header">
						<i className="fa fa-info productization-note__header__icon m-r-md"></i>
						{title}
					</h4>
					{/* InfoTitleCollapse must be open by default */}
					<Collapse isOpen={!on} className="m-t-sm">
						<div className="productization-note">
							<ul>
								{requirements.map(({ text, header }, index) =>
									header ? (
										<span className="productization-note__item">{text}</span>
									) : (
										<li className="productization-note__item ml-5" key={index}>
											{text}
										</li>
									)
								)}
							</ul>
						</div>
					</Collapse>
				</>
			)}
		</Toggle>
	);
};

InfoTitleCollapse.propTypes = {
	title: string.isRequired,
	requirements: array.isRequired
};

export default InfoTitleCollapse;
